import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=cdd2487c&scoped=true&functional=true&"
var script = {}
import style0 from "./Player.vue?vue&type=style&index=0&id=cdd2487c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "cdd2487c",
  null
  
)

export default component.exports